import { BannerOverlay } from "@/components/BannerOverlay/BannerOverlay";
import { ContactButton } from "@/components/ContactButton";
import { Box, Container, Typography, useTheme } from "@mui/material";

export function ContactUsSection() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: { xs: 290, sm: 400, lg: 590 },
        backgroundImage: `url(business_meeting.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "relative",
        backgroundPositionX: "center",
        backgroundAttachment: "fixed",
        "@supports (-webkit-touch-callout: none)": {
          backgroundAttachment: "scroll !important",
        },
      }}
    >
      <BannerOverlay />

      <Container
        sx={{
          height: "100%",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            maxWidth: {
              xs: "100%",
              lg: 600,
            },
            display: "flex",
            flexDirection: "column",
            gap: 2,
            color: theme.palette.common.white,
            textAlign: {
              xs: "center",
              lg: "left",
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "26px",
                sm: "40px",
              },
              lineHeight: 1,
            }}
            variant="h2"
          >
            O que você está esperando?
            <br /> Conheça nossos serviços agora!
          </Typography>
          <Typography sx={{ fontSize: { xs: "14px", sm: "18px" } }} variant="h6">
            Na RT Soluções Tributárias, transformamos impostos pagos a mais em economia para sua empresa. Com nossos
            serviços de recuperação de tributos, auditoria de cadastros e monitoramento contínuo, garantimos mais
            segurança fiscal, redução de custos e tranquilidade para você focar no que realmente importa: o crescimento
            do seu negócio.
          </Typography>

          <Box>
            <ContactButton />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
